var React = require('react');

function TripUpgrade (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.49 23.509c.61.61 1.615.61 2.226 0L20.809 5.416v8.759c0 .431.179.826.467 1.113.288.287.682.467 1.113.467.862 0 1.58-.718 1.58-1.58V1.61c0-.862-.718-1.58-1.58-1.58H9.823c-.862 0-1.58.718-1.58 1.58 0 .862.718 1.58 1.58 1.58h8.759L.526 21.247c-.647.646-.647 1.651-.036 2.262z"}));
}

TripUpgrade.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = TripUpgrade;

TripUpgrade.default = TripUpgrade;
